import React from 'react';
import { StarIcon } from 'lucide-react';
const stats: Array<{
  value: React.ReactNode;
  label: string;
}> = [{
  value: '+500',
  label: 'seños'
}, {
  value: <>
        4.9/5 <StarIcon className="mb-0.5 inline h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-235" data-mp="1obewhngqihhs" />
      </>,
  label: ''
}, {
  value: '6+5',
  label: 'tomos + bonos'
}, {
  value: 'AR',
  label: 'todo el país'
}];
export function StatsBar() {
  return <section className="w-full bg-forest-900 px-5 py-4" aria-label="Datos del MegaPack" data-id="element-236" data-mp="1ee0swofwtn6w">
      <ul className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-6 gap-y-3 divide-cream/15 sm:flex-nowrap sm:justify-between sm:divide-x" data-id="element-237" data-mp="19lg27vsavq7l">
        {stats.map((stat, index) => <li key={index} className="flex items-baseline justify-center gap-1.5 sm:flex-1 sm:px-4" data-id="element-238" data-mp="10mm0jr0449n6" data-mpi={index}>
            <span className="font-display text-lg font-extrabold text-cream sm:text-xl" data-id="element-239" data-mp="vmzovlzxn1gh">
              {stat.value}
            </span>
            {stat.label && <span className="text-xs font-bold text-lime-400 sm:text-sm" data-id="element-240" data-mp="qpzewzzypek3">{stat.label}</span>}
          </li>)}
      </ul>
    </section>;
}